import Immutable from 'immutable';

const initState = Immutable.fromJS({
  reports: [],
  receipts: [],
  isReportsDataReady: null,
  isAutoMateMailingReady: null,
  isReportsDataErrorOccurred: false,
  isAutoMateMailingReadyErrorOccurred: false,
  errorMessage: null,
  automateMailing: {
    isLoading: false,
  },
});

const actionHandlers = {

  SERVER_ERROR: state => state.mergeDeep({
    isReportsDataErrorOccurred: true,
    isReportsDataReady: true,
    automateMailing: {
      isLoading: false,
    },
  }),


  RECEIVE_REPORTS: (state, action) => {
    const { resBody } = action;

    return state.merge({
      reports: resBody.data,
      csvDownloadLink: resBody.csv_download_link,
      csvDownloadUrl: resBody.csv_download_files_url,
      receipts: resBody.receipts,
      isReportsDataReady: true,
    });
  },

  REQUEST_REPORTS: state => state.merge({
    isReportsDataErrorOccurred: false,
    isReportsDataReady: false,
    isAutoMateMailingReadyErrorOccurred: false,
    isAutoMateMailingReady: false,
    isReportDataReceived: false,
  }),

  REQUEST_AUTOMATE_MAILING_REPORTS: state => state.mergeDeep({
    isAutoMateMailingReady: false,
    automateMailing: {
      isLoading: true,
    },
  }),

  RECEIVE_AUTOMATE_MAILING_REPORTS: (state, action) => {
    const { error } = action.resBody;

    return state.mergeDeep({
      isAutoMateMailingReady: true,
      isAutoMateMailingReadyErrorOccurred: !!error,
      errorMessage: error,
      automateMailing: {
        isLoading: false,
      },
    });
  },
};

export default (state = initState, action) => {
  const actionHandler = actionHandlers[action.type];
  if (!actionHandler) return state;

  return actionHandler(state, action);
};



/** WEBPACK FOOTER **
 ** ./src/redux/reducers/reportsTabReducer.js
 **/